import { render } from "./a-tasks-skelet.vue?vue&type=template&id=fa6b1ade&scoped=true"
const script = {}

import "./a-tasks-skelet.vue?vue&type=style&index=0&id=fa6b1ade&lang=sass&scoped=true"

import exportComponent from "/opt/bitnami/apps/ocmsta/subdomains/praxisti/htdocs/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa6b1ade"]])

export default __exports__